blue.ready('swapBackground', '.swapBackground', (swap) => {
	swapBackground(swap, {
		mediaQuery: 768
	});
});
